/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Scenario } from '@scenario/models/scenario.model';
import { Dependencies } from '@configurations/dependencies/dependencies';
import {
  retrieveScenariosFailure,
  retrieveScenariosSuccess,
} from '@store/scenario/scenarios/scenarios-slice';
import { RootState } from '@store/create-store';
import { SearchScenariosFormModel } from '@app/scenarios/search-scenarios-form/search-scenarios-form.model';

export const retrieveScenariosByFiltersEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('scenarios/retrieveScenariosByFilters'),
    concatMap((action: PayloadAction<SearchScenariosFormModel>) =>
      from(dependencies.scenarioGateway.retrieveByFilters(action.payload)).pipe(
        map((scenarios: Scenario[]) => retrieveScenariosSuccess(scenarios)),
        catchError(() => of(retrieveScenariosFailure('Fail to retrieve scenarios'))),
      ),
    ),
  );
